import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/Solicitation',
    name: 'Solicitation',
    component: () => import('@/components/XuCheng.vue'), 
    meta: {
      title: '电子档案'
    },
    beforeEnter: (to, from, next) => {
      document.title = to.meta.title;
      next();
    }
  },
  {
    path: '/fileManagement',
    name: 'fileManagement',
    component: () => import('@/components/WenJianGuanLi.vue'),
    meta: {
      title: '电子档案'
    },
    beforeEnter: (to, from, next) => {
      document.title = to.meta.title;
      next();
    }
  },
  {
    path: '/VersionComparison',
    name: 'VersionComparison',
    component: () => import('@/components/VersionComparison.vue'),
    meta: {
      title: '文档对比' // 设置路由元信息中的标题
    },
    beforeEnter: (to, from, next) => {
      document.title = to.meta.title;
      next();
    }
  }
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});
export default router;
